import { Component, OnInit } from '@angular/core';
import { NavbarService } from '../../services/navbar.service';

@Component({
  selector: 'app-carrusel',
  templateUrl: './carrusel.component.html'
})
export class CarruselComponent implements OnInit {

  carruselList:any = [];

  navbar: NavbarService;

  constructor(private navbarService: NavbarService) {
    this.carruselList.push(new Carrusel('Home Box', 'Somos la mejor opción para transportar tus cargas aéreas y marítimas.', 'La alternativa más rentable al momento de elegir cómo recibir, almacenar y transportar tus compras de manera segura.',  'Registrate para obtener tu casilla en Estados Unidos', 'assets/intro-carousel/cargoplane.jpg', true, 'Registrate!', 'registro-online'));
    this.carruselList.push(new Carrusel('Compras', 'Si no contas con una tarjeta de crédito para tus compras #HaceloFácil, acercate a nosotros y realizamos la compra por vos.', '', '', 'assets/intro-carousel/direccion-miami.jpg', false, 'Registrate!', 'registro-online'));
    this.carruselList.push(new Carrusel('Envíos aéreos', 'Trae tus compras de manera segura, rápida y confiable al mejor precio.', '','', 'assets/intro-carousel/enviosareos.jpg', false, 'Registrate!', 'registro-online'));
    this.carruselList.push(new Carrusel('Envíos marítimos', '¿Buscas una tarifa conveniente?', '¡Con HomeBox olvidate de pagar costos elevados!', 'Cotizamos tus envíos al precio justo.',    'assets/intro-carousel/direccion-asu.jpg', false, 'Registrate!', 'registro-online'));

  }

  ngOnInit() {
    this.navbar = this.navbarService;
  }

}

class Carrusel {
  titulo: string;
  descripcionLinea1: string;
  descripcionLinea2: string;
  descripcionLinea3: string;
  imagen: string;
  activo: boolean;
  boton: string;
  redirec : string = "#";

  constructor(titulo: string, descripcionLinea1: string, descripcionLinea2: string, descripcionLinea3: string, imagen: string, activo: boolean, boton:string, redirec:string) {
    this.titulo = titulo;
    this.descripcionLinea1 = descripcionLinea1;
    this.descripcionLinea2 = descripcionLinea2;
    this.descripcionLinea3 = descripcionLinea3;
    this.imagen = imagen;
    this.activo = activo;
    this.boton = boton;
    if (redirec){
      this.redirec = redirec;
    }
  }

}
